import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@material-ui/core'
import {Container, Box, Grid} from '@material-ui/core'
import {FormControl, Checkbox, InputLabel, Select, MenuItem} from '@material-ui/core'
import {Button, TextField, OutlinedInput} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { PERMISSIONS } from '../../api/ServerApi';
import { isNumber } from '../../../api/validators';

class UserPropertiesDialog_ extends React.Component{

    constructor(props){
        super(props)

        //const {user} = this.props; 
        //const {device} = this.props;
        console.log('UserPropertiesDialog constructor')
        console.log('props')
        console.log(props)
        this.state = {
            properties: props.properties,
            errors:{
                pollingTime: false
            },
            changed: false,
        }

        this.handleInput =  this.handleInput.bind(this)
    }

    handleSave(){
        if(this.validate()){
            let properties = {...this.state.properties}
            this.props.onAction({
                type: 'USER_PROPERTIES_DIALOG_SAVE', 
                properties: properties,
                networkID: this.props.networkID,
                userID: this.props.user.ID,
                deviceID: this.props.device ? this.props.device.ID : null
            })
        }
    }

    handleClose(){
        if(this.state.changed){
            if(!window.confirm(this.props.t('CloseFormConfirm'))) return; 
        }
        this.props.onAction({type: 'USER_PROPETIES_DIALOG_CLOSE'})
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const properties = {...this.state.properties, [event.target.name]: val}
        this.setState({properties: properties, ...changed})
    }

    validate(){
        const {t} = this.props

        let errors = this.state.errors;
        let error = false

        
        //if(!this.state.properties.pollingTime){
        //    errors.ChannelNum = t('ChannelNumIsEmpty')
        //    error = true
        //}else 
        if(this.state.properties.pollingEnabled && !isNumber(this.state.properties.pollingTime)){
            errors.pollingTime = t('IsNotNumber')
            error = true
        }else{
            errors.pollingTime = false
        }
/*
        if(!this.state.channel.ChannelName){
            errors.ChannelName = t('NameIsEmpty')
            error = true
        }else{
            errors.ChannelName = false
        }
        this.setState({errors: errors})
        */

        return !error;
    }

    checkPermission(permission){
        return this.props.onAction({
            type:'CHECK_PERMISSION', 
            networkID: this.props.networkID, 
            permission: permission 
        })
    }


    render(){
        const {t} = this.props

        const title = t('Properties')

        const margin = {margin:'16px 0 8px 0'}

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="properties-dialog-title">
        
    <DialogTitle id="properties-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>
            <Box textAlign="center">
                <Grid container style={{width:'100%', border2:'1px solid red'}} alignItems="center">
                    <Grid item xs={5} align="left">
                        
                        {this.props.avatar?
                        <img style={{width:100}} alt="User avatar" src={"data:image/jpg;base64,"+ this.props.avatar} />
                        :
                        <PersonIcon color="disabled" style={{width:100, height: 100}}/>
                        }
                        
                    </Grid>
                    <Grid item xs={7} align="left">
                        <Typography style={{fontWeight: 'bold'}}>
                            {this.props.user.Name}
                        </Typography>
                    </Grid>
                </Grid>    
            </Box>

            {!this.checkPermission(PERMISSIONS.OP_RESTRICTLOCATIONTRACKREPORT)?(
            <>
            <Box textAlign="" style={{...margin, width: '100%'}}>
                {t('LocationSettings')}:
            </Box>
            <Box  textAlign="" style={{...margin, width: '100%'}}>
                <Checkbox color="primary" 
                    checked={this.state.properties.pollingEnabled}
                    onChange={this.handleInput}
                    name="pollingEnabled"
                />
                <label>
                    {t('PollingTime')}
                    <OutlinedInput  type="text" name="pollingTime"
                        id={"pollingTime-input"}
                        style={{width: 100, margin:'0 10px', padding:0}}
                        autoComplete="new-password"
                        disabled={!this.state.properties.pollingEnabled}
                        value={this.state.properties.pollingTime}
                        error={this.state.errors["pollingTime"]!==false}
                        onChange={this.handleInput}
                        aria-describedby={"pollingTime-helper-text"}
                    />

                    {this.state.errors["pollingTime"]!==false?
                    <span style={{color:'red', whiteSpace:'nowrap'}} id={"pollingTime-helper-text"}>
                        {this.state.errors["pollingTime"]}
                    </span>
                    :''}
                    
                </label>
            </Box>
            </>
            ):''}

            <Box textAlign="left">
            <FormControl style={{...margin, width: '100%'}}>
                <InputLabel htmlFor="ProfileID">{t('Profile')}</InputLabel>
                <Select
                    value={this.state.properties.profileID}
                    onChange={this.handleInput}
                    inputProps={{name: 'profileID', id: 'profileID'}}
                    >
                    {this.props.profiles.map(profile=>
                        <MenuItem key={profile.ProfileID} value={profile.ProfileID}>{profile.Name}</MenuItem>
                    )}
                </Select>
            </FormControl>
            </Box>

            <Box textAlign="center" style={{marginTop:16}}>
                {/*this.props.device.DeviceDescription*/}
                {this.props.device && this.props.device.DeviceDescription?
                    <TextField
                        id="outlined-multiline-static"
                        label={t("DeviceDescription")}
                        multiline
                        rows="4"
                        variant="outlined"
                        value={this.props.device.DeviceDescription}
                        style={{width:'100%'}}
                    />:''
                }

            </Box>


        
        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const UserPropertiesDialog = withTranslation()(UserPropertiesDialog_);